<template>
	<div class="listItem" @click="onClickMoveToDetail">
		<div class="bookmark">{{ idx }}</div>
		<div class="c_inner">
			<div class="item_pick">
				<img :src="data.image_path" alt="대가 이미지" loading="lazy" />
				<span class="item_title">{{ data.rise_rate_category_name }}</span>
			</div>
			<div class="item_total">
				<span
					:class="
						Number(
							data.rise_rate_weekly_rate ??
								data.rise_rate_monthly_rate ??
								data.rise_rate_quarterly_rate ??
								data.rise_rate_annual_rate
						) > 0
							? 'plus'
							: 'minus'
					"
				>
					{{
						formatWithSign(
							data.rise_rate_weekly_rate ??
								data.rise_rate_monthly_rate ??
								data.rise_rate_quarterly_rate ??
								data.rise_rate_annual_rate ??
								''
						)
					}}%
				</span>
				<img class="arrow" src="@/assets/img/common/arrow_next.svg" alt="화살표" loading="lazy" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { RiseSectorTheme } from '@/api/topGaining';
import { CANCEL, CONFIRM_LOGIN, LOGIN_REQUIRED_PAGE } from '@/constants/title';
import { useLoginPopupStore } from '@/stores/LoginPopup';
import { useTokenStore } from '@/stores/token';
import { formatWithSign } from '@/utils/function/format';
const props = defineProps<{
	data: RiseSectorTheme;
	idx: number;
	sort: string;
}>();

const router = useRouter();
const tokenStore = useTokenStore();
const loginPopupStore = useLoginPopupStore();
const onClickMoveToDetail = async () => {
	if (!tokenStore.isLogin) {
		loginPopupStore.openPopup({
			icon: 'alert',
			content: LOGIN_REQUIRED_PAGE,
			confirm: () => router.push('/auth/login'),
			confirmText: CONFIRM_LOGIN,
			cancelText: CANCEL,
		});
		return;
	}

	// TopGaining 상세로 이동
	router.push(`/topgaining/topgaining-detail/${props.sort}/${props.data.rise_rate_pk}`);
};
</script>

<style lang="scss" scoped>
.listItem {
	display: flex;
	width: 100%;
	background-color: var(--color-bg-mid);
	color: var(--color-base-white);
	border-radius: var(--space-x-small);
	white-space: nowrap;
	cursor: pointer;
	min-width: 0;
	.bookmark {
		border-radius: var(--space-x-small) 0 0 var(--space-x-small);
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: var(--color-bg-light);
		font-weight: var(--font-w-semi-bold);
		font-size: var(--font-s-x-large);
		line-height: 2.387rem;
		width: 3.4rem;
		padding: 1rem 1.2rem;
	}
	.c_inner {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 1rem;
		padding: 2rem 1rem;
		max-width: none;
		min-width: 0;
		.item_pick {
			display: flex;
			align-items: center;
			gap: 1rem;
			overflow: hidden;
			min-width: 0;
			img {
				object-fit: contain;
				width: 4rem;
				height: 4rem;
			}
			.item_title {
				display: block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: var(--font-s-regular);
				color: var(--color-base-white);
				font-weight: var(--font-w-semi-bold);
				line-height: 2.1rem;
			}
		}
		.item_total {
			display: flex;
			align-items: center;
			gap: 0.8rem;
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			.plus {
				color: var(--color-danger);
			}
			.minus {
				color: var(--color-secondary-Blue);
			}
			flex-shrink: 0;
		}
	}
	.detail {
		display: flex;
		justify-content: center;
		align-items: center;
		.detail_item {
			display: flex;
			align-items: center;
			gap: 1rem;
			font-size: var(--font-s-mid);
			color: var(--color-base-white);
			font-weight: var(--font-w-medium);
			canvas {
				font-size: var(--font-s-mid);
				color: var(--color-base-white);
				font-weight: var(--font-w-medium);
			}
		}
		.c_button {
			padding: 0.7rem 1.6rem;
		}
	}
}
</style>
